var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "span",
      {
        class: [
          "label-text",
          { "add-colon": _vm.level === 0 && _vm.hasSelectedChildsToLastLevel }
        ]
      },
      [
        _vm.item.freeText
          ? _c("span", [_vm._v(_vm._s(_vm.item.freeText))])
          : _c("Label", {
              attrs: {
                characteristic: _vm.item.item,
                "label-type": _vm.labelType
              }
            }),
        _vm._v(" "),
        !_vm.isLastLevel &&
        !_vm.hasSelectedChildsToLastLevel &&
        _vm.noChildrenAppendix
          ? _c("span", [
              _vm._v(
                "\n\t\t\t(" + _vm._s(_vm.computedNoChildrenAppendix) + ")\n\t\t"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.labelAppendix
          ? _c("span", { staticClass: "label-appendix" }, [
              _vm._v(_vm._s(_vm.labelAppendix))
            ])
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.hasIcon
      ? _c("span", { staticClass: "label-icon" }, [
          _c("img", {
            attrs: {
              src: _vm.iconPath + "/" + _vm.item.item.naturalId + ".svg",
              alt: _vm.item.item.label
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }